export const aiSearchMockRes = {
    filters: [
        {
            column: 'CURDATE',
            operator: 'Between',
            values: ['START_LAST_WEEK', 'TOMORROW']
        },
        {
            column: 'STATDES',
            operator: 'Equals',
            values: ['Active']
        },
        {
            column: 'CUSTNAME',
            operator: 'StartsWith',
            values: ['0000']
        },
        {
            column: 'CREATEDDATE',
            operator: 'Between',
            values: ['TODAY', 'END_THIS_WEEK']
            // values: ['2024-12-15', '2024-12-19']
        },
        // it's a filters mock response for Chart of Accounts form
        {
            column: 'CLOSED',
            operator: 'Equals',
            values: ['true']
        },
        {
            column: 'INACTIVE',
            operator: 'Equals',
            values: ['true']
        },
        {
            column: 'CREATEDDATE',
            operator: 'Later',
            values: ['2024-12-15']
        },
        {
            column: 'MULTICURFLAG',
            operator: 'Equal',
            values: ['true']
        },
        {
            column: 'COUNTRYNAME',
            operator: 'Equals',
            values: ['Ukraine', 'United States']
        }
    ]
};
